const routers = [
  {
    path: '/',
    redirect: '/auth/login-choice', // default redirect to new login choice
    auth: false
  },
  {
    component: 'AuthLayout',
    path: '/auth',
    auth: false,
    name: 'Auth',
    exact: false,
    childrens: [
      {
        component: 'Login',
        path: '/login',
        componentPath: 'pages/Auth/login',
        name: 'Login',
        auth: false,
        exact: true
      },
      {
        component: 'SSOLoginSuccessPage',
        path: '/sso-success',
        componentPath: 'pages/Auth/SSOLoginSuccess',
        name: 'SSOLoginSuccessPage',
        auth: false,
        exact: true
      },
      {
        component: 'LoginChoice',
        path: '/login-choice',
        componentPath: 'pages/Auth/LoginChoice',
        name: 'LoginChoice',
        auth: false,
        exact: true
      },
      {
        component: 'ForgotPassword',
        path: '/forgot-password',
        componentPath: 'pages/Auth/ForgotPassword.jsx',
        name: 'ForgotPassword',
        auth: false,
        exact: true
      },
      {
        component: 'VerifyOtp',
        path: '/verifyotp',
        componentPath: 'pages/Auth/VerifyOtp.jsx',
        name: 'VerifyOtp',
        auth: false,
        exact: true
      },
      {
        component: 'ResetPassword',
        path: '/reset-password',
        componentPath: 'pages/Auth/ResetPassword.jsx',
        name: 'ResetPassword',
        auth: false,
        exact: true
      }
    ]
  },
  {
    component: 'MainLayout',
    path: '/typography',
    auth: false,
    name: 'Typography',
    exact: false,
    childrens: [
      {
        component: 'Login',
        path: '/',
        componentPath: 'pages/typography',
        name: 'TypographyPage',
        auth: false,
        exact: true
      }
    ]
  },
  {
    component: 'MainLayout',
    path: '/home',
    auth: false,
    name: 'MainLayout',
    exact: false,
    childrens: [
      {
        component: 'ManageProductsList',
        path: '/manage-products',
        componentPath: 'pages/Home/ManageProducts/ManageProductsList.jsx',
        name: 'ManageProductsList',
        auth: false,
        exact: true
      },
      {
        component: 'Pre Eligibility Leads',
        path: '/pre-eligibility',
        componentPath: 'pages/Home/PreEligibility/PreEligibilityLeads.jsx',
        name: 'Pre Eligibility Leads',
        auth: false,
        exact: true
      },
      {
        component: 'Pre Eligibility Leads Details',
        path: '/pre-eligibility-details',
        componentPath: 'pages/Home/PreEligibility/PreEligibilityDetail.jsx',
        name: 'Pre Eligibility Leads Details',
        auth: false,
        exact: true
      },
      {
        component: 'Mandate Transactions',
        path: '/mandate-transactions',
        componentPath: 'pages/Home/CadKycDetails/MandateTransactions.jsx',
        name: 'Mandate Transactions',
        auth: false,
        exact: true
      },
      {
        component: 'ModifyRules',
        path: '/manage-products/modify-rules',
        componentPath: 'pages/Home/ManageProducts/ModifyRules.jsx',
        name: 'ModifyRules',
        auth: false,
        exact: true
      },
      // {
      //   component: 'ModifyRules',
      //   path: '/manage-products/modify-rules',
      //   componentPath: 'pages/Home/ManageProducts/ModifyRules.jsx',
      //   name: 'ModifyRules',
      //   auth: false,
      //   exact: true
      // },
      // {
      //   component: 'ModifyRules',
      //   path: '/manage-products/modify-rules/edit/:editRules',
      //   componentPath: 'pages/Home/ManageProducts/ModifyRules.jsx',
      //   name: 'ModifyRules',
      //   auth: false,
      //   exact: true
      // },
      {
        component: 'BreMasterList',
        path: '/manage-bre',
        componentPath: 'pages/Home/ManageBre/BreMasterList.jsx',
        name: 'BreMasterList',
        auth: false,
        exact: true
      },
      {
        component: 'BreExecutionsPage',
        path: '/bre-executions',
        componentPath: 'pages/Home/Bre/BreExecutions.jsx',
        name: 'BreExecutionsPage',
        auth: false,
        exact: true
      },
      {
        component: 'ProductPartnershipSetup',
        path: '/product-partner-setup',
        componentPath:
          'pages/Home/ProductPartnershipSetup/ProductPartnership.jsx',
        name: 'ProductPartnershipSetup',
        auth: false,
        exact: true
      },
      {
        component: 'AddSupplier',
        path: '/product-partner-setup/add-suppliers',
        componentPath: 'pages/Home/ProductPartnershipSetup/AddSupplier.jsx',
        name: 'AddSupplier',
        auth: false,
        exact: true
      },
      {
        component: 'ProductpartnerMapSuppliers',
        path: '/product-partner-setup/map-suppliers',
        componentPath: 'pages/Home/ProductPartnershipSetup/MapSupplier.jsx',
        name: 'ProductpartnerMapSuppliers',
        auth: false,
        exact: true
      },
      {
        component: 'ProductPartnerModifyRules',
        path: '/product-partner-setup/modify-rules',
        componentPath:
          'pages/Home/ProductPartnershipSetup/ProductPartnerModifyRules.jsx',
        name: 'ProductPartnerModifyRules',
        auth: false,
        exact: true
      },
      {
        component: 'AddFieldPage',
        path: '/product-partner-setup/modify-rules/add-fields',
        componentPath: 'pages/Home/ProductPartnershipSetup/AddFields.jsx',
        name: 'AddFieldPage',
        auth: false,
        exact: true
      },
      {
        component: 'AddFields',
        path: '/partner-management/view-partner-product-setup/modify-rules/add-fields',
        componentPath: 'pages/Home/ViewPartners/AddFields.jsx',
        name: 'AddFields',
        auth: false,
        exact: true
      },
      {
        component: 'UserManagementList',
        path: '/user-management',
        componentPath: 'pages/Home/UserManagement/UserManagementList.jsx',
        name: 'UserManagementList',
        auth: false,
        exact: true
      },
      {
        component: 'ViewPartnersList',
        path: '/partner-management',
        componentPath: 'pages/Home/ViewPartners/ViewPartnersList.jsx',
        name: 'ViewPartnersList',
        auth: false,
        exact: true
      },
      {
        component: 'ViewPartnerManagementDetails',
        path: '/partner-management/view/:id',
        componentPath:
          'pages/Home/ViewPartners/ViewPartnerManagementDetails.jsx',
        name: 'ViewPartnerManagementDetails',
        auth: false,
        exact: true
      },
      {
        component: 'ModifyBranches',
        path: '/partner-management/modify-branch',
        componentPath: 'pages/Home/ViewPartners/ModifyBranches.jsx',
        name: 'ModifyBranches',
        auth: false,
        exact: true
      },
      {
        component: 'ViewPartnerProducts',
        path: '/partner-management/view-partner-products',
        componentPath: 'pages/Home/ViewPartners/ViewPartnerProducts.jsx',
        name: 'ViewPartnerProducts',
        auth: false,
        exact: true
      },
      {
        component: 'AddSuppliers',
        path: '/partner-management/add-supplier',
        componentPath: 'pages/Home/ViewPartners/AddSuppliers.jsx',
        name: 'AddSuppliers',
        auth: false,
        exact: true
      },
      {
        component: 'ViewProductPartnerList',
        path: '/partner-management/view-partner-product-setup',
        componentPath: 'pages/Home/ViewPartners/ViewProductPartnerList.jsx',
        name: 'ViewProductPartnerList',
        auth: false,
        exact: true
      },
      {
        component: 'ViewPartnerModifyRules',
        path: '/partner-management/view-partner-product-setup/modify-rules',
        componentPath: 'pages/Home/ViewPartners/ViewPartnerModifyRules.jsx',
        name: 'ViewPartnerModifyRules',
        auth: false,
        exact: true
      },
      {
        component: 'PartnerMapSuppliers',
        path: '/partner-management/view-partner-product-setup/map-suppliers',
        componentPath: 'pages/Home/ViewPartners/MapSuppliers.jsx',
        name: 'PartnerMapSuppliers',
        auth: false,
        exact: true
      },
      {
        component: 'Reports',
        path: '/reports',
        componentPath: 'pages/Home/Reports/Reports.jsx',
        name: 'Reports',
        auth: false,
        exact: true
      },
      {
        component: 'PartnerRecommendation',
        path: '/partner-recommendation',
        componentPath:
          'pages/Home/PartnerRecommendation/PartnerRecommendation.jsx',
        name: 'PartnerRecommendation',
        auth: false,
        exact: true
      },
      {
        component: 'AdminControlPanel',
        path: '/admin-control-panel',
        componentPath: 'pages/Home/AdminControlPanel/AdminControlPanel.jsx',
        name: 'AdminControlPanel',
        auth: false,
        exact: true
      },
      {
        component: 'RepaymentSchedule',
        path: '/partner-recommendation/repayment-schedule',
        componentPath: 'pages/Home/PartnerRecommendation/RepaymentSchedule.jsx',
        name: 'RepaymentSchedule',
        auth: false,
        exact: true
      },
      {
        component: 'CBBO',
        path: '/cbbo',
        componentPath: 'pages/Home/CBBO/CBBO.jsx',
        name: 'CBBO',
        auth: false,
        exact: true
      },
      {
        component: 'FPO',
        path: '/cbbo/fpo',
        componentPath: 'pages/Home/CBBO/FPO.jsx',
        name: 'FPO',
        auth: false,
        exact: true
      },
      {
        component: 'CADManagement',
        path: '/cad-management',
        componentPath: 'pages/Home/CADManagement/CADManagement.jsx',
        name: 'CADManagement',
        auth: false,
        exact: true
      },
      {
        component: 'CAD Farmer List',
        path: '/cad-farmerlist',
        componentPath: 'pages/Home/CadFarmerList/CadFarmerList.jsx',
        name: 'CAD Farmer List',
        auth: false,
        exact: true
      },
      {
        component: 'CAD Kyc Details',
        path: '/cad-kycdetails',
        componentPath: 'pages/Home/CadKycDetails/CadKycDetails.jsx',
        name: 'CAD Kyc Details',
        auth: false,
        exact: true
      },
      {
        component: 'Cad Dashboard',
        path: '/cad-dashboard',
        componentPath: 'pages/Home/CadDashboard/CadDashboard.jsx',
        name: 'Cad Dashboard',
        auth: false,
        exact: true
      },
      {
        component: 'Insight',
        path: '/insight',
        componentPath: 'pages/Home/Tools/Insight.jsx',
        name: 'Insight',
        auth: false,
        exact: true
      },
      {
        component: 'Requests',
        path: '/requests',
        componentPath: 'pages/Home/Requests/Requests.jsx',
        name: 'Requests',
        auth: false,
        exact: true
      },
      {
        component: 'Tools',
        path: '/tools',
        componentPath: 'pages/Home/Tools/PincodeList.jsx',
        name: 'Tools',
        auth: false,
        exact: true
      },
      {
        component: 'User Logs',
        path: '/userLogs',
        componentPath: 'pages/Home/Tools/UserLogs.jsx',
        name: 'User Logs',
        auth: false,
        exact: true
      },
      {
        component: 'Product Repayment Mode',
        path: '/productRepaymentModeMapping',
        componentPath: 'pages/Home/Tools/ProductRepaymentModeMapping.jsx',
        name: 'Product Repayment Mode',
        auth: false,
        exact: true
      },
      {
        component: 'Rule Master List',
        path: '/ruleMasterListView',
        componentPath: 'pages/Home/Tools/RuleMasterListView.jsx',
        name: 'Rule Master List',
        auth: false,
        exact: true
      },
      {
        component: 'Request Param Master List',
        path: '/requestParamMasterListView',
        componentPath: 'pages/Home/Tools/RequestParamMasterListView.jsx',
        name: 'Request Param Master List',
        auth: false,
        exact: true
      },
      {
        component: 'Multiple Digital Stamp',
        path: '/multiple-digital-stamp',
        componentPath:
          'pages/Home/MultipleDigitalStamp/MultipleDigitalStamp.jsx',
        name: 'Multiple Digital Stamp',
        auth: false,
        exact: true
      },
      {
        component: 'Document Management',
        path: '/legality-management/dashboard',
        componentPath: 'pages/Home/LegalityDashboard/LegalityDashboard.jsx',
        name: 'Legality Dashboard',
        auth: false,
        exact: true
      },
      {
        component: 'SignDesk',
        path: '/signDesk',
        componentPath: 'pages/Home/SignDeskDashboard/SignDeskDashboard.jsx',
        name: 'SignDesk',
        auth: false,
        exact: true
      },
      {
        component: 'Document Management',
        path: '/legality-management/after-flip',
        componentPath: 'pages/Home/LegalityDocs/LegalityDocsAfterFlip.jsx',
        name: 'Document Management After Flip',
        auth: false,
        exact: true
      },
      {
        component: 'Document Management',
        path: '/legality-management/post-flip',
        componentPath: 'pages/Home/LegalityDocs/LegalityDocs.jsx',
        name: 'Document Management Post Flip',
        auth: false,
        exact: true
      },
      {
        component: 'Document Management',
        path: '/legality-management/btst',
        componentPath: 'pages/Home/LegalityDocs/LegalityDocsBTST.jsx',
        name: 'Document Management BTST',
        auth: false,
        exact: true
      },
      {
        component: 'Miscellaneous Assets',
        path: '/legality-management/miscellaneous-assets',
        componentPath: 'pages/Home/MiscellaneousAssets/MiscellaneousAssets.jsx',
        name: 'Miscellaneous Assets',
        auth: false,
        exact: true
      },
      {
        component: 'No Due Certificate',
        path: '/no-due-certificate',
        componentPath: 'pages/Home/NoDueCertificate/NoDueCertificate.jsx',
        name: 'No Due Certificate',
        auth: false,
        exact: true
      },
      {
        component: 'Intimation Letter',
        path: '/intimation-letter',
        componentPath: 'pages/Home/IntimationLetter/IntimationLetter.jsx',
        name: 'Intimation Letter',
        auth: false,
        exact: true
      },
      {
        component: 'Credit PD Report',
        path: '/credit-pd-report',
        componentPath: 'pages/Home/CreditPDReport/CreditPDReport.jsx',
        name: 'Credit PD Report',
        auth: false,
        exact: true
      },
      {
        component: 'Field Master Setup View',
        path: '/fieldMasterSetupView',
        componentPath: 'pages/Home/Tools/FieldMasterSetupView.jsx',
        name: 'Field Master Setup View',
        auth: false,
        exact: true
      },
      {
        component: 'Health Check View',
        path: '/health-check',
        componentPath: 'pages/Home/HealthCheck/HealthCheck.jsx',
        name: 'Health Check View',
        auth: false,
        exact: true
      },
      {
        component: 'BatchDisbursementList',
        path: '/batch-disbursement-list',
        componentPath: 'pages/Home/BulkDisbursement/BatchDisbursementList.jsx',
        name: 'BatchDisbursementList',
        auth: false,
        exact: true
      },
      {
        component: 'BulkDisbursementList',
        path: '/bulk-disbursement-list',
        componentPath: 'pages/Home/BulkDisbursement/BulkDisbursementList.jsx',
        name: 'BulkDisbursementList',
        auth: false,
        exact: true
      },
      {
        component: 'INSURANCE',
        path: '/insurance-dashboard',
        componentPath: 'pages/Home/CALI/CaliDashboard.jsx',
        name: 'INSURANCE',
        auth: false,
        exact: true
      },
      {
        component: 'Insurance Details',
        path: '/insurance-details',
        componentPath: 'pages/Home/CALI/CaliDetails.jsx',
        name: 'Insurance Details',
        auth: false,
        exact: true
      },
      {
        component: 'Insurance Detail',
        path: '/all-insurance',
        componentPath: 'pages/Home/CALI/CaliDetails.jsx',
        name: 'Insurance Detail',
        auth: false,
        exact: true
      }
    ]
  },
  {
    component: 'HealthCheckLayout',
    path: '/health-check',
    auth: false,
    name: 'HealthCheckPage',
    exact: false,
    childrens: [
      {
        component: 'HealthCheckPage',
        path: '/',
        componentPath: 'pages/HealthCheck/HealthCheck',
        name: 'HealthCheckPage',
        auth: false,
        exact: true
      }
    ]
  },
  {
    component: 'CommonLayout',
    path: '/common',
    auth: false,
    name: 'CommonLayout',
    exact: false,
    childrens: [
      {
        component: 'TermsandConditionsPage',
        path: '/terms-and-conditions',
        componentPath: 'pages/CommonPages/TermsandConditions',
        name: 'TermsandConditionsPage',
        auth: false,
        exact: true
      },
      {
        component: 'PartnersPage',
        path: '/partners',
        componentPath: 'pages/CommonPages/Partners',
        name: 'PartnersPage',
        auth: false,
        exact: true
      }
    ]
  }
  // {
  //   component: 'ErrorLayout',
  //   path: '*',
  //   auth: false,
  //   name: 'ErrorLayout',
  //   exact: false,
  //   childrens: [
  //     {
  //       component: 'Page404',
  //       path: '*',
  //       componentPath: 'pages/Page404/Page404.jsx',
  //       name: 'Page404',
  //       auth: false,
  //       exact: true
  //     }
  //   ]
  // }
];

export default routers;
